import { Controller } from '@hotwired/stimulus';
import MapController from './map_controller';

export default class ProgressUpdatePreviewController extends Controller<HTMLInputElement> {
  public static outlets: string[] = ['map'];
  declare private readonly hasMapOutlet: boolean;
  declare private readonly mapOutlet: MapController;
  declare private readonly distanceTarget: HTMLInputElement;
  declare private readonly distanceUnitTarget: HTMLSelectElement;

  public static readonly targets = ['distance', 'distanceUnit'];

  public connect(): void {
    this.distanceTarget.addEventListener('change', this.update.bind(this));
    this.distanceUnitTarget.addEventListener('change', this.update.bind(this));
  }

  public update(): void {
    if (!this.distanceTarget.checkValidity()) {
      return;
    }

    this._updateMap(
      this.distanceTarget.valueAsNumber,
      this.distanceUnitTarget.value
    ).catch(err => console.log(err));
  }

  private async _updateMap(newDistance: number, newDistanceUnit: string) {
    if (!this.hasMapOutlet) {
      return;
    }

    let urlValue = this.mapOutlet.geoJsonUrlValue;

    if (urlValue.startsWith('/')) {
      urlValue = [location.origin, urlValue].join('');
    }

    const url = new URL(urlValue);

    url.searchParams.set('distance', newDistance.toString());
    url.searchParams.set('distance_unit', newDistanceUnit.toString());

    const data = await this.mapOutlet.load(url.toString());
    // Nice to have: Zoom to the preview path

    console.log(data);
  }
}
